<template>
  <v-container
    id="target-table"
    tag="section"
  >
    <base-material-card
      color="bgTemperature"
      icon="mdi-coolant-temperature"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgTemperature pa-7">
          {{ title }}
        </div>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['admissionDate']"
        :sort-desc="[false]"
        :loading="loading"
        show-expand
      >
        <template v-slot:item.admissionDate="{ item }">
          {{ item.admissionDate | formatDate }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-card>
              <v-card-title>
                <span class="headline">{{ $t('sensors') }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr
                          v-for="targetDevice in item.targetDevice"
                          :key="targetDevice.id"
                        >
                          <td>
                            <router-link :to="{ name: 'temperatureview', params: { id: targetDevice.id }}">
                              {{ targetDevice.description }}
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-container>
              </v-card-text>
            </v-card>
          </td>
        </template>>
      </v-data-table>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>
<style>
.bgTemperature{
  background-color: #023A66 !important;
}
</style>
<script>
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const targetRespository = repositoryFactory.get('targets')

  export default {
    name: 'TargetList',
    mixins: [filters],
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('temperatures')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.temperatures.description'),
            value: 'description',
          },
          {
            text: this.$t('tables.temperatures.admissionDate'),
            value: 'admissionDate',
          },
          {
            text: this.$t('tables.temperatures.code'),
            value: 'code',
          },
        ]
      },
    },
    watch: {
      $route (to, from) {
        this.fetchDate()
      },
    },
    mounted () {
      this.fetchDate()
    },
    methods: {
      fetchDate () {
        var self = this
        var type = 'TE'
        self.loading = true
        targetRespository.get(type).then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.showErrorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      addTarget () {
        this.$router.push({ name: 'target', params: { id: 'add' } })
      },
    },
  }
</script>
